import script from "./ProjectRelatedBuildingSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectRelatedBuildingSelector.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectRelatedBuildingSelector.vue?vue&type=style&index=0&id=810380f2&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-810380f2"]])

export default __exports__